module.exports = __webpack_public_path__ + "img/newsImg4.09a1b540.png";